export default __webpack_public_path__ + "static/Sketches-71386bb71e59ebbe6b3d5cb6691c9715.png";